import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CoachBotTopBarComponent } from 'libs/coach-bot/ui/src/components';
import { getBranding, getTitle } from '../../utils';

@Component({
  selector: 'dh-top-bar',
  templateUrl: './dashboard-top-bar.component.html',
  styleUrls: [
    '../../../../../coach-bot/ui/src/components/coach-bot-top-bar/coach-bot-top-bar.component.scss',
    './dashboard-top-bar.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardTopBarComponent extends CoachBotTopBarComponent {
  @Output() public openProfileSettings = new EventEmitter();

  public logo = `assets/dashboard/images/${getBranding().toLowerCase()}-logo.png`;
  public title: string = getTitle();

  onLogout(): void {
    this.logout.emit();
  }

  onOpenProfileSettings(): void {
    this.openProfileSettings.emit();
  }
}
